<template>
    <div class="create-notification">
        <div class="modal-list" :class="{'display': !isOpen, 'display-block': isOpen}">
            <div>
                <h3 @click="isOpen = false">X</h3>
                <center>
                    <h3>Agregar pendiente manual</h3>
                </center>
                <button @click="addModelsToNotificacion">Agregar Modelos</button>
                <span v-if="modelSelected" @click="modelSelected = !modelSelected"><i class="fa-solid fa-arrow-left"></i></span>
                <div v-else class="list">
                    <input type="text" v-model="searchValue" v-on:keyup="checkTrigger" @keyup.enter="onEnter">
                    <div class="model-list" v-infinite-scroll="loadMoreModels" infinite-scroll-disabled="busyModels" infinite-scroll-distance="200">
                        <div v-for="(model, index) in modelWithOut" @click="selectModelToAddNotification(model)" :key="index" :class="{'select': model.select}">
                            <div>
                                <center><img :src="model.image" alt=""></center>
                                <h5 for="">{{ model.name }}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="change_date" :title="selectTitulo">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3 for="">Nueva Fecha</h3>
                <input type="date" v-model="newDate">
                <button @click="changeDate">Cambiar Fecha</button>
            </div>
        </b-modal>
        <div>
            <div class="notifications">
                <div class="table">
                    <center>
                        <h3>Lista de Notificaciones</h3>
                        <div v-for="(item, index) in notificationsList" :key="index" @click="selectedNotification(index)" :class="{'select': item.select}">
                            <label class="border-label" style="width: 100px">{{item.created_at.split($store.state.constants.SEPARETOR)[0]}}</label>
                            <label class="border-label" style="width: 400px">{{item.titulo}}</label>
                            <label class="border-label">{{item.system_status}}</label>
                            <label>{{item.tipo}}</label>
                        </div>
                    </center>
                </div>
                <div class="details">
                    <center><h3>{{selectTitulo}}</h3></center>
                    <div>
                        <div>
                            <label for="">Fecha: <span>{{selectCreated}}</span></label>
                            <label for="">Grupo: <span>{{selectGroup}}</span></label>
                            <label for="">Tipo: <span>{{selectType}}</span></label>
                        </div>
                        <div>
                            <label for="">Creador: <span>{{selectWho}}</span></label>
                            <label for="">F. envio: <span>{{selectDate}}</span></label>
                            <label for="">Estado: <span>{{selectStatus}}</span></label>
                            <label for="">Cantidad: <span>{{selectCant}}</span></label>
                        </div>
                        <div>
                            <label for="">Detalles</label>
                            <p>{{selectDetails}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="models">
                <div>
                    <div class="list">
                    <center><h3>Lista de modelos</h3></center>
                        <div v-for="(item, index) in modelsList" :key="index">
                            <img :src="item.photo" alt="">
                            <div>
                                <label for="">{{ item.model }}</label>
                                <span>{{ item.turno }}</span>
                                <span>{{ item.tipo }}</span>
                            </div>
                            <label><h5 v-on:click="deleteModel(item.model_id)">X</h5></label>
                        </div>
                        <button @click="isOpen = true">Agregar modelo</button>
                    </div>
                    <div class="controls">
                        <div>
                            <button @click="deleteNotification">Eliminar</button>
                            <button @click="resetNotification">Reestablecer</button>
                            <button @click="() => {this.$refs.change_date.show()}">Cambiar Fecha</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Notify from '@/utils/Notification.js'

export default {
    data() {
        return {
            modelsList: [],
            notificationsList: [],
            limit: 30,
            offset: 0,
            selectTitulo: null,
            selectCreated: null,
            selectGroup: null,
            selectType: null,
            selectWho: null,
            selectDate: null,
            selectStatus: null,
            selectCant: null,
            selectDetails: null,
            back_index: -1,
            isOpen: false,
            modelSelected: null,
            searchValue: '',
            limitModels: 20,
            offsetModels: 0,
            busyModels: false,
            listEndModels: false,
            itemFlagModels: false,
            modelWithOut: [],
            modelToAdd: [],
            newDate: null
        }
    },
    props: {
        notification_id: Number
    },
    watch: {
        searchValue: function() {
            if (this.searchValue === '') {
                this.models = []
                this.addModel()
            }
        }
    },
    methods: {
        checkTrigger(e) {
            if (e.keyCode === 13) {
                this.limitModels = 20
                this.offsetModels = 0
                this.modelWithOut = []
                this.searchModel()
            } else if (this.searchValue.length > 0) {
                this.limitModels = 20
                this.offsetModels = 0
                this.modelWithOut = []
                this.searchModel()
            }
        },
        onEnter () {
            this.searchModel()
        },
        searchModel() {
            this.modelSearch = false
            this.addModel()
        },
        loadMoreModels() {
            if (this.searchValue !== '') {
                return
            }
            this.busyModels = true
            if (!this.listEndModels) {
                setTimeout(() => {
                    if (this.modelWithOut.length < this.offsetModels) {
                        this.listEndModels = true
                        return
                    }
                    if (this.itemFlagModels) {
                        this.addModel()
                        this.busyModels = false
                    } else {
                        this.loadMoreModels()
                    }
                }, 1000)
            }
        },
        changeDate() {
            API.notificationChangeDate(this.notification_id, {date: this.newDate})
                .then((res) => {
                    this.$refs.change_date.hide()
                    this.getNotifications()
                    Notify('dirty', 'Se cambio la fecha de la notificacion con exito')
                })
        },
        resetNotification() {
            API.resetNotification(this.notification_id)
                .then((res) => {
                    this.getNotifications()
                    Notify('dirty', 'Se ha cambiado el estado de la notificacion con exito')
                })
        },
        deleteNotification() {
            API.deleteNotification(this.notification_id)
                .then((res) => {
                    this.getNotifications()
                    Notify('dirty', 'Se ha eliminado la notificacion con exito')
                })
        },
        selectModelToAddNotification(item) {
            if (this.modelToAdd.indexOf(item.id) > -1) {
                this.modelToAdd.splice(this.modelToAdd.indexOf(item.id), 1)
            } else {
                this.modelToAdd.push(item.id)
            }
            item.select = !item.select
        },
        addModelsToNotificacion() {
            API.addModelsToNotificacion(this.notification_id, {models: this.modelToAdd})
                .then((res) => {
                    this.isOpen = false
                    this.modelToAdd = []
                    this.modelWithOut = []
                    this.searchValue = ''
                    this.limitModels = 20
                    this.offsetModels = 0
                    this.busyModels = false
                    this.listEndModels = false
                    this.itemFlagModels = false
                    this.getNotifications()
                    Notify('dirty', 'Se agregaron las modelos a la notificacion con exito')
                })
        },
        deleteModel(id) {
            API.deleteNotificationByModel(id, this.notification_id)
                .then((res) => {
                    this.getNotifications()
                    this.modelWithOut = []
                    this.searchValue = ''
                    this.limitModels = 20
                    this.offsetModels = 0
                    this.busyModels = false
                    this.listEndModels = false
                    this.itemFlagModels = false
                    Notify('dirty', 'Se elimino la modelo de la notificacion con exito')
                })
        },
        addModel() {
            const limit = this.searchValue === '' ? this.limitModels : 'ALL'
            const offset = this.searchValue === '' ? this.offsetModels : 0
            var searchValueinitial = ''
            if (this.searchValue !== '') {
                var stagenameSeparate = this.searchValue.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchValue
                }
            } else {
                searchValueinitial = this.searchValue
            }
            API.getModelWithOutNofitication(this.notification_id, limit, offset, searchValueinitial)
                .then((res) => {
                    if (this.searchValue !== '') {
                        this.modelWithOut = res
                    } else {
                        res.map(item => { this.modelWithOut.push(item) })
                        this.offsetModels += this.limitModels
                        this.itemFlagModels = true
                    }
                })
        },
        selectedNotification(index) {
            if (this.back_index >= 0) {
                this.notificationsList[this.back_index].select = false
            }
            this.notificationsList[index].select = true
            this.selectTitulo = this.notificationsList[index].titulo
            this.selectCreated = this.notificationsList[index].created_at.split(this.$store.state.constants.SEPARETOR)[0]
            this.selectGroup = this.notificationsList[index].group
            this.selectType = this.notificationsList[index].type
            this.selectWho = this.notificationsList[index].who
            this.selectDate = this.notificationsList[index].time_send.split(this.$store.state.constants.SEPARETOR)[0]
            this.selectStatus = this.notificationsList[index].system_status
            this.selectCant = this.notificationsList[index].cantidad
            this.selectDetails = this.notificationsList[index].detalles
            this.modelsList = this.notificationsList[index].modelos
            this.back_index = index
            this.addModel()
        },
        getNotifications() {
            API.getNotifications(this.limit, this.offset, 'pausada')
                .then((res) => {
                    if (!(res.length > 0)) {
                        this.selectTitulo = null
                        this.selectCreated = null
                        this.selectGroup = null
                        this.selectType = null
                        this.selectWho = null
                        this.selectDate = null
                        this.selectStatus = null
                        this.selectCant = null
                        this.selectDetails = null
                        this.modelsList = null
                        this.notificationsList = []
                        return
                    }
                    this.notificationsList = res
                    var index
                    if (!this.notification_id || this.notification_id === undefined) {
                        this.notification_id = this.notificationsList[0].id
                        index = 0
                    } else {
                        index = this.notificationsList.findIndex(object => { return object.id === this.notification_id })
                    }
                    this.selectedNotification(index)
                })
        }
    },
    mounted() {
        this.getNotifications()
    }
}
</script>

<style scoped>
    .create-notification {
        background-color: #cdcdcd;
        height: 90vh;
        color: #000;
        display: flex;
        position: relative;
    }
    .create-notification > div {
        display: contents;
        width: 100%;
        padding: 20px;
        display: flex;
    }
    .create-notification > div.modal-list {
        padding: 40px;
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: rgba(43, 41, 38, 0.7);
        z-index: 99;
        border-radius: 0px;
    }
    .create-notification > div.modal-list > div{
        background-color: #FFF;
        height: 90%;
        width: 90%;
        padding: 20px;
        color: #000;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
    .create-notification > .display{
        display: none;
    }
    .create-notification > .display-block{
        display: block;
    }
    .create-notification > div.modal-list > div > div.list{
        padding: 20px;
        height: 100%;
    }
    .create-notification > div.modal-list > div > div.list > input{
        width: 100%;
        height: 50px;
        border-radius: 20px;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .create-notification > div.modal-list > div > div.list > div.model-list{
        padding: 20px;
        overflow: auto;
        height: 80%;
        position: relative;
    }
    .create-notification > div.modal-list > div > div.list > div.model-list > div{
        width: 25%;
        display: inline-block;
    }
    .create-notification > div.modal-list > div > div.list > div.model-list > div.select {
        background-color: #63b763;
    }
    .create-notification > div.modal-list > div > div.list > div.model-list > div > div{
        padding: 20px;
        width: 100%;
        text-align: center;
    }
    .create-notification > div.modal-list > div > div.list > div.model-list > div > div > center > img{
        width: 50%;
        height: 50%;
        object-fit: cover;
    }
    .create-notification > div.modal-list > div > button {
        position: absolute;
        top: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .create-notification > div.modal-list > div > h3 {
        font-weight: bolder;
        position: absolute;
        right: 20px;
    }
    .create-notification > div.modal-list > div > span > svg {
        font-weight: bolder;
        position: absolute;
        left: 20px;
        top: 27px;
        font-size: 28px;
    }
    .create-notification > div.modal-list > div > h3:hover {
        color: red;
        cursor: pointer;
    }
    .create-notification > div.modal-list > div > span > svg:hover {
        color: red;
        cursor: pointer;
    }
    .create-notification > div > .notifications {
        width: 60%;
        height: 100%;
    }
    .create-notification > div > .notifications > .table{
        width: 100%;
        height: 60%;
        padding: 20px;
        border-radius: 20px;
        border-style: outset;
        background-color: #63b1b7;
    }
    .create-notification > div > .notifications > .table > center {
        width: 100%;
    }
    .create-notification > div > .notifications > .table > center > h3 {
        color: #fff;
    }
    .create-notification > div > .notifications > .table > center > div {
        background: #2b2926;
        margin: 20px;
        color: #fff;
        border-radius: 20px;
        height: 30px;
        position: relative;
        width: 90%;
    }
    .create-notification > div > .notifications > .table > center > .select {
        background-color: #22bb33;
    }
    .create-notification > div > .notifications > .table > center > div > label {
        width: 20%;
    }
    .create-notification > div > .notifications > .details{
        width: 100%;
        height: 38%;
        padding: 20px;
        border-radius: 20px;
        border-style: outset;
        background-color: #8363b7;
    }
    .create-notification > div > .notifications > .details > div {
        display: flex;
        width: 100%;
    }
    .create-notification > div > .notifications > .details > div > div{
        width: 33%;
        display: grid;
    }
    .create-notification > div > .notifications > .details > div > div > label{
        font-size: 20px;
        color: #fff;
        font-weight: bold;
    }
    .create-notification > div > .notifications > .details > div > div > p{
        font-size: 20px;
        color: #000;
        float: right;
        padding-right: 30px;
        background-color: #fff;
        text-align: center;
        border-radius: 20px;
    }
    .create-notification > div > .notifications > .details > div > div > label > span{
        font-size: 18px;
        color: #000;
        float: right;
        padding-right: 30px;
        text-transform: capitalize;
    }
    .create-notification > div > .notifications > .details > center > h3 {
        color: #fff;
        background-color: #2b2926;
    }
    .create-notification > div > .models {
        width: 40%;
        height: 100%;
        padding-left: 20px;
    }
    .create-notification > div > .models > div{
        height: 100%;
    }
    .create-notification > div > .models > div > .list > center > h3 {
        color: #fff;
    }
    .create-notification > div > .models > div > .list{
        width: 100%;
        height: 80%;
        border-radius: 20px;
        border-style: outset;
        padding: 20px;
        background-color: #585858;
        margin-bottom: 1rem;
        position: relative;
        overflow-y: auto;
    }
    .create-notification > div > .models > div > .list > div {
        background: #2b2926;
        margin: 20px;
        color: #fff;
        border-radius: 20px;
        height: 100px;
        position: relative;
        display: flex;
        padding: 10px 40px;
    }
    .create-notification > div > .models > div > .list > div > img {
        width: 80px;
        height: 80px;
        object-fit: cover;
        margin-right: 60px;
        border-radius: 50%;
    }
    .create-notification > div > .models > div > .list > div > div {
        display: grid;
        text-align: left;
    }
    .create-notification > div > .models > div > .list > div > label > h5 {
        font-weight: bolder;
        right: 20px;
    }
    .create-notification > div > .models > div > .list > div > label > h5:hover {
        color: red;
        cursor: pointer;
    }
    .create-notification > div > .models > div > .list > button{
        position: absolute;
        background-color: #e0b059;
        color: #fff;
        border-radius: 30px;
        font-weight: bold;
        width: 160px;
        left: 50%;
        transform: translate(-50%);
    }
    .create-notification > div > .models > div > .list > div > label{
        text-align: center;
        height: 100%;
        padding: 3px;
        position: absolute;
        right: 20px;
    }
    .create-notification > div > .models > div > .list > div > label >.vista{
        background-color: #22bb33;
        height: 100%;
        border-radius: 20px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .create-notification > div > .models > div > .list > div > label > .entregada {
        background-color: #63b1b7;
        height: 100%;
        border-radius: 20px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .create-notification > div > .models > div > .controls {
        width: 100%;
        height: 18%;
        padding: 20px;
        border-radius: 20px;
        border-style: outset;
        background-color: #63b78c;
        position: relative;
    }
    .create-notification > div > .models > div > .controls > div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        display: flex;
    }
    .create-notification > div > .models > div > .controls > div > button{
        background-color: #e0b059;
        color: #fff;
        border-radius: 30px;
        font-weight: bold;
        margin: 10px;
        width: 140px;
    }
    .info-wrapper > div > h3 {
        margin: 20px;
    }
    .info-wrapper > div{
        width: 80%;
    }
    .info-wrapper > div > div {
        background: #2b2926;
        margin: 20px;
        color: #fff;
        border-radius: 20px;
        height: 30px;
        position: relative;
        width: 100%;
        cursor: pointer;
    }
    .info-wrapper > div > div > label{
        width: 32%;
        text-align: center;
        height: 100%;
        padding: 3px;
    }
    .info-wrapper > button {
        background-color: #e0b059;
        color: #fff;
        width: 200px;
        height: 30px;
        border-radius: 30px;
        margin: 30px;
    }
    .info-wrapper > div > .select {
        background-color: #22bb33;
    }
    .info-wrapper > h3 {
        text-align: center;
        margin: 30px;
    }
    .info-wrapper > input {
        width: 250px;
        height: 50px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Notificaciones/NotificationPause.vue